import { useCommercialSegmentsStore } from "@/store/commercialSegment";
import { useCountriesStore } from "@/store/country";
import { getVisitorsByIds } from "../api/visitor";
import { CommercialSegment } from "../types/commercialSegment";
import { Country } from "../types/country";
import { Visitor, VisitorCreateDTO, VisitorDTO } from "../types/visitor";

export async function fetchVisitorsByIds(ids: string[]): Promise<Visitor[]> {
    const res = await getVisitorsByIds(ids)

    const commercialSegmentsStore = useCommercialSegmentsStore()
    const countriesStore = useCountriesStore()

    return res.map(dto => dtoToVisitor(dto, commercialSegmentsStore.commercialSegments, countriesStore.countries))
}

function dtoToVisitor(dto: VisitorDTO, commercialSegments: CommercialSegment[], countries: Country[]): Visitor {
    const commercialSegment = dto.commercialSegmentId
        ? commercialSegments.find(cs => cs.id === dto.commercialSegmentId) || null
        : null

    const country = dto.countryId
        ? countries.find(c => c.id === dto.countryId) || null
        : null

    return {
        id: dto.id,
        firstName: dto.firstName,
        lastName: dto.lastName,
        email: dto.email,
        type: dto.type,
        erpCode: dto.erpCode,
        representsPurchaseGroup: dto.representsPurchaseGroup,
        commercialSegment,
        functionaryId: dto.functionaryId,
        functionaryName: null,
        agentId: dto.agentId,
        agentName: null,
        country,
        businessName: dto.businessName,
        role: dto.role,
        activitySector: dto.activitySector
    }
}

export function visitorToDTO(visitor: Visitor): VisitorCreateDTO {
    return {
        id: visitor.id || undefined,
        firstName: visitor.firstName,
        lastName: visitor.lastName,
        email: visitor.email,
        type: visitor.type,
        erpCode: visitor.erpCode,
        representsPurchaseGroup: visitor.representsPurchaseGroup,
        commercialSegmentId: visitor.commercialSegment ? visitor.commercialSegment.id : undefined,
        functionaryId: visitor.functionaryId,
        agentId: visitor.agentId,
        countryId: visitor.country ? visitor.country.id : undefined,
        businessName: visitor.businessName,
        role: visitor.role,
        activitySector: visitor.activitySector
    }
}
